import axios from 'axios';

import history from './history';
import config from '../config';

import UserAPI from './UserAPI';

const apiPath = config.api.proposals;

function url(...rest) {
  return rest.map(val => `${val}`.replace(/\/$/, '')).join('/');
}

class ProposalUserAPI {
  static get(proposalId, searchParams = undefined) {
    return axios({
      method: 'get',
      url: url(apiPath, proposalId, 'users'),
      params: searchParams,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static post(proposalId, data) {
    return axios({
      method: 'post',
      url: url(apiPath, proposalId, 'users'),
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static put(proposalId, data) {
    return axios({
      method: 'put',
      url: url(apiPath, proposalId, 'users'),
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static delete(proposalId, data) {
    return axios({
      method: 'delete',
      url: url(apiPath, proposalId, 'users'),
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static getCollaborator(proposalId) {
    return axios({
      method: 'get',
      url: url(apiPath, proposalId, 'collaborator'),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static updateCollaborator(proposalUserId, data) {
    return axios({
      method: 'put',
      url: url(config.api.proposalUsers, proposalUserId),
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }
}

export default ProposalUserAPI;
